import React, { useEffect, useState } from "react";
import ChildList from "../components/ChildList";

export function ResponsibleList() {
  const [childList, setChildList] = useState([]);

  useEffect(() => {
    let childs = localStorage.getItem("CHILDS");
    childs =
      childs && childs.length > 1 ? childs.substring(0, childs.length - 2) : "";
    setChildList(JSON.parse(`[${childs}]`));
  }, []);

  return (
    <div className="container my-3 py-5">
      <main className="mt-5">
        <h3 className="fw-light pb-2">
          <i className="bi bi-person-vcard"></i> Responsáveis
        </h3>
        {childList && childList.length > 0 ? (
          <ul>
            <ChildList childs={childList}></ChildList>
          </ul>
        ) : (
          "Nenhum dado cadastrado..."
        )}
      </main>
    </div>
  );
}
